import React, { useState } from 'react';
import { gsap } from 'gsap';
import ReactPlayer from 'react-player';
import style from './style.module.scss';
import { className } from 'soluble-design-system-base';

// hack para limpiar los inline styles al hacer resize para prevenir estilos dejados por gsap
function bumpIt() {
    if (typeof window === 'undefined') {
        return;
    }
    if (document.getElementById('heroVideo') === null) {
        return;
    }

    if (document.getElementById('heroVideo').classList.contains('playing')) {
        return;
    }

    document.getElementById('heroVideo').removeAttribute('style');
    document.getElementsByTagName('body')[0].removeAttribute('style');
}

let didResize = false;

setInterval(function () {
    if (didResize) {
        didResize = false;
        bumpIt();
    }
}, 500);

function Container(props) {
    const wrapper = React.useRef();
    const videoContainer = React.useRef();

    const [videoState, setVideoState] = useState({
        playing: false,
    });

    const tl = React.useRef();

    React.useEffect(() => {
        if (document.getElementById('heroVideo') === null) {
            return;
        }
        tl.current = gsap
            .timeline({
                paused: true,
                onStart: () => {
                    document
                        .getElementById('heroVideo')
                        .classList.add('playing');
                },
                onReverseComplete: () => {
                    document
                        .getElementById('heroVideo')
                        .classList.remove('playing');
                    document
                        .getElementById('heroVideo')
                        .removeAttribute('style');
                    document
                        .getElementsByTagName('body')[0]
                        .removeAttribute('style');
                },
            })
            .set('#areaVideoCursor', { display: 'none' })
            .set('body', {
                position: 'fixed',
                overflow: 'hidden',
                width: '100vw',
                height: '100vh',
            })
            .set(['#navbar'], { display: 'none' })
            .from('#heroVideo', { scale: 0 })
            .to(
                '#heroVideo',
                {
                    scale: 1,
                    transformOrigin: '50% 50%',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 4,
                    autoAlpha: 1,
                    width: '100vw',
                    height: '100vh',
                    background: '#172128',
                    // duration: 0.2,
                    // autoRound: false,
                },
                '<'
            )
            .to('#heroVideoText', { autoAlpha: 0, duration: 0.2 }, '<')
            .set('#areaVideoCursor', { position: 'fixed', display: 'flex' });
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', (event) => {
                didResize = true;
            });
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', (event) => {});
            }
        };
    }, []);

    return (
        <div
            style={{
                backgroundImage: props.backgroundImage
                    ? `url(${props.backgroundImageWide})`
                    : '',
            }}
            ref={wrapper}
            {...className(
                `${style.container} ${props.containerCpm || ''} ${
                    props.backgroundImage ? style.backgroundImage : ''
                }`
            )}
        >
            {props.backgroundImage && (
                <>
                    <img
                        {...className(
                            `${props.backgroundClassName} ${style.bgDesktopWide}`
                        )}
                        src={props.backgroundImageWide}
                    />
                    <img
                        {...className(
                            `${props.backgroundClassName} ${style.bgDesktop}`
                        )}
                        src={props.backgroundImage}
                    />
                    <img
                        id="bgMobilePoster"
                        {...className(
                            `${props.backgroundClassName} ${style.bgMobile}`
                        )}
                        src={props.backgroundImageMobile}
                    />
                    {props.video?.src && (
                        <div
                            id="heroVideo"
                            className={style.video}
                            ref={videoContainer}
                        >
                            <ReactPlayer
                                width={'100%'}
                                height={'100%'}
                                controls={false}
                                playing={videoState.playing}
                                url={props.video.src}
                                config={{
                                    vimeo: {
                                        controls: false,
                                    },
                                }}
                            />
                        </div>
                    )}
                </>
            )}

            {props.video?.src && (
                <div
                    id="areaVideoCursor"
                    {...className(`${props.areaVideoCursorClassName}`)}
                    onClick={() => {
                        setVideoState({
                            ...videoState,
                            playing: !videoState.playing,
                        });
                        if (
                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                navigator.userAgent
                            )
                        ) {
                            const fullscreenElement =
                                document.fullscreenElement ||
                                document.mozFullScreenElement ||
                                document.webkitFullscreenElement ||
                                document.msFullscreenElement;
                            if (fullscreenElement) {
                                //exitFullscreen();
                            } else {
                                /*launchIntoFullscreen(
                                    document.getElementById('heroVideo')
                                );*/
                            }
                            //screenfull.toggle(videoContainer.current);
                        }
                        if (videoState.playing) {
                            tl.current.reverse();
                            return;
                        }
                        tl.current.play();
                    }}
                >
                    <span>
                        {videoState.playing ? (
                            <>
                                <i className="aplazicon aplazicon-media-pause-default"></i>
                                Pause
                            </>
                        ) : (
                            <>
                                <i className="aplazicon aplazicon-media-play-default"></i>
                                Play
                            </>
                        )}
                    </span>
                </div>
            )}
            <div {...className(`${props.modifyPadding || ''}`)}>
                {props.children}
            </div>
        </div>
    );
}

export default Container;
